import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.darkBlue};
  align-items: left;
  height: auto;
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
`;

export const WrapperFrameHeader = styled.div`
  background: ${({ theme }) => theme.colors.darkBlue};
  align-items: left;
  height: auto;
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 28px;
  position: absolute;
  left: 45%;
  transform: translate(-50%, 0);
  font-style: normal;
`;

export const HeaderTop = styled.div(
  ({ paddingRule }) => css`
    position: relative;
    display: flex;
    padding: ${paddingRule};
    justify-content: space-between;
  `
);

export const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Circle = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
`;
